import { Component } from '@angular/core';
import { slideInUpOnEnterAnimation } from 'angular-animations';

@Component({
  selector: 'about-atomo',
  standalone: true,
  imports: [],
  templateUrl: './about-atomo.component.html',
  styleUrl: './about-atomo.component.scss',
  animations: [
    slideInUpOnEnterAnimation({ anchor: 'slideInOut' }),
  ]
})
export class AboutAtomoComponent {



}
